import { Injectable, Input } from '@angular/core';
import { ObjectListType, PageNames, BistrackConfig, SearchPageNames } from 'ep-bt-controls';
import {
  FieldAgentClient, CustomerSearchParameters, CustomerSearchParametersCustomerStatus, CustomerSearchParametersDeliverytype,
  SortParametersDirection, PagingParameters, SortParameters, CustomerContact, Attachment
} from 'ep-bt-field-agent-proxy';
import { EpbtFaSortService } from './epbt-fa-sort.service';

@Injectable({
  providedIn: 'root'
})

export class EpbtFaContactsService {

  pageSize = 10;

  @Input() customerId: number;
  public contactSrcId: number;
  public searchString: string;


  customerContact: CustomerContact;
  public fromPage: string = PageNames.ContactsSearch;



  constructor(private client: FieldAgentClient, private sortService: EpbtFaSortService, private config: BistrackConfig, ) { }

  getCustomerContactByContactID(customerContactId: number,
    subscribe: (contact: any) => void) {

    this.client.getCustomerContact(customerContactId).subscribe(res => {
      subscribe(res);
      // console.log('result :' + res);
    });
  }

  getCustomerAttachmentsByContactID(customerContactId: number,
    subscribe: (contact: any) => void) {

    this.client.getObjectAttachments(customerContactId, ObjectListType.CustomerContact).subscribe(res => {
      subscribe(res);
      console.log('attach :' + res);
    });
  }

  deleteAttachmentsByAttachmentObj(attachment: Attachment,
    subscribe: (flag: boolean) => void) {

    this.client.deleteAttachment(attachment).subscribe(res => {
      subscribe(res);
      console.log('delete :' + res);
    });
  }

  addCustomerContactPost(addCustomerContact: CustomerContact,
    subscribe: (contactId: number) => void) {

    this.client.addCustomerContact(addCustomerContact).subscribe(res => {
      subscribe(res);
      // console.log('result :' + res);
    });
  }

  updateCustomerContactPut(updateCustomerContact: CustomerContact,
    subscribe: (contactId: number) => void) {

    this.client.saveCustomerContact(updateCustomerContact).subscribe(res => {
      subscribe(res);
      // console.log('result :' + res);
    });
  }




  // This method will return single customer contact if the only one record is matching with the search string
  getCustomerContacts(searchString: string, customerId: number, subscribe: (customer: any) => void) {
    // contact api start
    const searchCustomerParams = new CustomerSearchParameters();
    searchCustomerParams.customerStatus = CustomerSearchParametersCustomerStatus.CustomerOrProspect;
    searchCustomerParams.customersLimitSearchToHomeBranch = true;
    searchCustomerParams.bisTrackUserID = this.config.getLoggedinUser();
    searchCustomerParams.competitor = 0;
    const page = new PagingParameters();
    page.count = this.pageSize;
    searchCustomerParams.paging = page;
    const sort = new SortParameters();
    if (this.sortService.currentPageName == SearchPageNames.CustomerContactSearch) {
      sort.sortColumn = this.sortService.customerConatctSortValue;
      sort.direction = this.sortService.customerConatctDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    } else {
      sort.sortColumn = this.sortService.dashboardConatctSortValue;
      sort.direction = this.sortService.dashboardConatctDirectionValue == 0 ? SortParametersDirection.Ascending : SortParametersDirection.Descending;
    }

    searchCustomerParams.sorting = sort;
    searchCustomerParams.searchText = searchString;
    searchCustomerParams.deliverytype = CustomerSearchParametersDeliverytype.All;
    searchCustomerParams.productGroupId = 0;
    searchCustomerParams.quicklistId = 0;
    searchCustomerParams.showProductsInCurrentGroupOnly = false;
    searchCustomerParams.customerId = customerId;

    searchCustomerParams.restrictProductGroupsToCustomer = false;
    searchCustomerParams.refineIDs = null;
    searchCustomerParams.refineValues = null;
    searchCustomerParams.priceLevels = null;
    searchCustomerParams.branchID = 0;
    searchCustomerParams.bisTrackUserHasReadAccessToTheseBranchIDs = null;
    searchCustomerParams.defaultOnly = false;
    searchCustomerParams.includeMOLTProducts = false;
    this.client.findContacts(searchCustomerParams).subscribe(res => {
      if (res && res.lines.length == 1) {
        subscribe(res.lines[0]);
      } else {
        subscribe(false);
      }
    });
  }

}
